
const videoElements = document.querySelectorAll('.wp-video-shortcode');

if( videoElements !== null && typeof dataLayer !== 'undefined' ) {
    videoElements.forEach( video => {
        const intervals = [0.25, 0.5, 0.75, 1];
        let lastLoggedInterval = 0;
        let sourceUrl = video.querySelector('source').src;

        video.addEventListener('play', function() {
            dataLayer.push({
                event: 'video_interaction',
                video_action: 'play',
                video_name: sourceUrl
            });

            video.addEventListener('pause', function() {
                dataLayer.push({
                    event: 'video_interaction',
                    video_action: 'pause',
                    video_name: sourceUrl
                });
            });

            video.addEventListener('stop', function() {
                dataLayer.push({
                    event: 'video_interaction',
                    video_action: 'stop',
                    video_name: sourceUrl
                });
            });

            video.addEventListener('timeupdate', function(e) {
                const playedPercentage = video.currentTime / video.duration;

                intervals.forEach((interval, index) => {
                    if (playedPercentage >= interval && lastLoggedInterval < interval) {
                        dataLayer.push({
                            event: 'video_interaction',
                            video_action: interval * 100,
                            video_name: sourceUrl
                        });

                        lastLoggedInterval = interval;
                    }
                });
            });

            video.addEventListener('volumechange', function(e) {
                dataLayer.push({
                    event: 'video_interaction',
                    video_action: 'volume_change',
                    video_name: sourceUrl,
                    volume: video.volume
                });


            });
        });
    })
}
